import {
  clearSnapshot,
  getReporteGeneralVendedor
} from "../../../actions/comisionAnualidad";
import { Preview } from "../../../../types/IAction";
import { GetSnapshot } from "../../../reducers/comisionAnualidad";

/**
 * REPORTE GENERAL DE VENDEDORES — mapDispatchToProps
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * Acciones Redux:
 * - clearAnualidadSnapshot: limpia snapshot al montar la pantalla.
 * - getReporteGeneralVendedor: consulta el reporte (periodo, idVendedor opcional, page/size).
 */
export interface ReporteGeneralVendedorDispatcher {
  clearAnualidadSnapshot: () => Promise<Preview<void>>;
  getReporteGeneralVendedor: (
    periodo: string,
    idVendedor: number | null,
    page?: number,
    size?: number
  ) => Promise<Preview<GetSnapshot>>;
}

export const reporteGeneralVendedorDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReporteGeneralVendedorDispatcher = dispatch => ({
  clearAnualidadSnapshot: () => {
    return dispatch(clearSnapshot());
  },
  getReporteGeneralVendedor: (
    periodo: string,
    idVendedor: number | null,
    page?: number,
    size?: number
  ) => {
    return dispatch(getReporteGeneralVendedor(periodo, idVendedor, page, size));
  }
});
